// extracted by mini-css-extract-plugin
export var conversationListItem = "_wo-2";
export var fullBleedList = "_wo-3";
export var messageText = "_wo-1";
export var previewText = "_wo-0";